import { LogLevel } from '@microsoft/signalr';

export class EnvironmentVariables {
  apiPath: string = '';
  authClientId: string = '';
  authRedirect: boolean | string[] = true;
  authScope: string[] = [];
  authServer: string = '';
  basePath: string = '';
  chatHub: string = '';
  development: boolean = false;
  diallerHub: string = '';
  logLevel: number = 0;
  notifyHub: string = '';
  presenceHub: string = '';
  production: boolean = false;
  staging: boolean = false;
}
